import { BUDDY_CONFIG } from 'config/buddy/config';
import type { AgentSummary } from '../agent-chat-module/types/agent.service.type';

/**
 * Finds the default "Buddy" agent by its fixed ID (VITE_BUDDY_AGENT_ID).
 * Matched by ID, not name — user agents like "Test Buddy" must not be treated as Buddy.
 * Returns null when Buddy is missing, archived, or disabled.
 */
export function findBuddyAgent(agents?: AgentSummary[] | null): AgentSummary | null {
  const buddy = agents?.find((agent) => agent.id === BUDDY_CONFIG.agentId);
  if (!buddy || buddy.is_archived || buddy.is_disabled) {
    return null;
  }
  return buddy;
}
